import React, {Component} from 'react'
import {
    InputNumber,
    Table,
    Button,
    message,
    notification,
    Select,
    Tag,
    Form,
    Radio,
    Input, Space,
    Tabs, Badge, Cascader, PageHeader, Row, Col, Pagination, Divider, Spin, Card, Popconfirm
} from 'antd';
import {
    getDataRightItem,
    getFieldDataRight,
    saveDataRightItem,delDataRightItemField
} from '../../../request'
import './index.less'
import * as Icon from '@ant-design/icons';
import {envHttpUrl} from '../../../http/globalMethod'

let columnsKey = {
    index: '序号',
    fieldName: '字段名',
    fieldType: "字段类型",
    fieldValue: "字段值",
    fieldAliasName: "别名",
    toast: "备注提示",
    query: "是否查询项",
    sort: "排序",
    titleColor: "表头颜色",
    operation: "操作",
}

const layout = {
    labelCol: {
        flex: '100px',
    },
    wrapperCol: {
        span: 22,
    },
};
const locationQuery = new URLSearchParams(window.location.search)

export default class DataRightDetail extends Component {
    formRef = React.createRef()
    tableRef = React.createRef()
    state = {
        defaultTab: '1',
        currentTab: locationQuery.get('tab') ? locationQuery.get('tab') : '1',
        dataSource: [],
        columns: [],
        loading: false,
        sqlLoading: false,
        visible: false,
        systemItem: {},
        messageClassMap: [],
        messageActionMap: [],
        messageClassFilter: [],
        mergeSendList: [],
        appList: [],
        messageTypeList: [],
        messageLevelList: [],
        messageSourceList: [],
        invokeTypeList: [],
        pushDingdingList: [],
        buttonActionList: [],
        linkOpenTypeList: [],
        userList: [],
        warnTypeList: [],
        moduleList: [],
        workFlowFormList: [],
        formParam: {
            id: this.props.match.params.id != 0 ? this.props.match.params.id : null,
            source:'默认',
            dataDetail:[]

        },
        newData:[],
        tableParam: {
            pageSize: 10,
            pageNum: 1
        },
        insertPos: '',
        insertVar: '',
        cronTime: '',
        total: 0,
        columnPreview: [],
        tableSqlData: [],
        tableWidth: 1000,
        dataSourceList:[
            {
                value: '默认',
                label: '默认',
            },{
                value: 'tools',
                label: 'tools',
            },{
                value: '接口',
                label: '接口',
            },{
                value: 'sql',
                label: 'sql',
            },
        ],
        newColor:'',
        colorOptions:[
            '#4ea72e','#fcc106','#c4dfb4','#ec7126',
            '#7f7f7f','#3f3f3f','#cd201f','#3b5899',
            '#efefef','#DEEDF2','#F6E5D9','#eb2f96',
            '#f5222e','#14c2c2','#722ed1','#fadb15',
            '#a0d90f','#2db7f5'
        ]
    };
    createColumns = (createKeys) => {
        let columns = Object.keys(createKeys).map(item => {
            console.log('key', item)
            let initObj = {
                title: createKeys[item],
                dataIndex: item,
                key: item,
                align: 'center'
            }
            if(item=='index'){
                return {
                    ...initObj,
                    width:50,
                    fixed: 'left',
                    render:(text,record,index)=>{
                        return index+1
                    }
                }
            } else if (item == 'fieldName'|| item == 'fieldAliasName') {
                return {
                    ...initObj,
                    width: 150,
                    align: 'left',
                    render: (text, record, index) => {
                        return (
                            <>
                                <Form.Item name={['dataDetail',index, item]}>
                                    <Input placeholder="请输入"/>
                                </Form.Item>
                            </>
                        )
                    }
                }

            } else if (item == 'toast') {
                return {
                    ...initObj,
                    width: 250,
                    align: 'left',
                    render: (text, record, index) => {
                        return (
                            <>
                                <Form.Item name={['dataDetail',index, item]}>
                                    <Input.TextArea autoSize={{minRows: 2, maxRows: 6}} placeholder="请输入"/>
                                </Form.Item>
                            </>
                        )
                    }
                }

            } else if (item == 'fieldType') {
                return {
                    ...initObj,
                    width: 100,
                    align: 'left',
                    render: (text, record, index) => {
                        return (
                            <>
                                <Form.Item name={['dataDetail',index, item]}>
                                    <Select
                                        allowClear
                                        placeholder="字段类型"
                                        options={[
                                            {label: '字符', value: '字符'},
                                            {label: '数字', value: '数字'},
                                            {label: '日期', value: '日期'},
                                        ]}
                                    />
                                </Form.Item>
                            </>
                        )
                    }
                }

            } else if (item == 'query') {
                return {
                    ...initObj,
                    width: 140,
                    align: 'left',
                    render: (text, record, index) => {
                        return (
                            <>
                                <Form.Item name={['dataDetail',index, item]}>
                                    <Radio.Group>
                                        <Radio value={1}>是</Radio>
                                        <Radio value={0}>否</Radio>
                                    </Radio.Group>
                                </Form.Item>
                            </>
                        )
                    }
                }

            } else if (item == 'sort') {
                return {
                    ...initObj,
                    width: 100,
                    align: 'left',
                    render: (text, record, index) => {
                        return (
                            <>
                                <Form.Item name={['dataDetail',index, item]}>
                                    <InputNumber style={{ width: '100%'}} />
                                </Form.Item>
                            </>
                        )
                    }
                }

            } else if (item == 'titleColor') {
                return {
                    ...initObj,
                    width: 140,
                    align: 'left',
                    render: (text, record, index) => {
                        return (
                            <>
                                <Form.Item name={['dataDetail', index, item]}>
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder="请选择"
                                        allowClear={ true}
                                        options={this.state.colorOptions.map(item=>({label:<Badge
                                                count={item}
                                                style={{ backgroundColor: item }}
                                            />,value:item}))}
                                    />
                                </Form.Item>
                            </>
                        )
                    }
                }

            } else if (item == 'fieldValue') {
                return {
                    ...initObj,
                    width: 300,
                    align: 'left',
                    render: (text, record, index) => {
                        return (
                            <>
                                <Form.Item name={['dataDetail',index, item]}>
                                    <Select
                                        value={ text}
                                        mode="tags"
                                        // tokenSeparators={[',']}
                                        options={[]}
                                    />
                                </Form.Item>

                            </>
                        )
                    }
                }

            } else if (item == 'operation') {
                return {
                    ...initObj,
                    align: 'left',
                    width: 50,
                    fixed: 'right',
                    render: (text, record, index) => {
                        return (
                            <>
                                <Popconfirm
                                    title="确定要删除该条数据吗？"
                                    onConfirm={()=>this.deleteItem(record,index)}
                                    okText="确认"
                                    cancelText="取消"
                                >
                                    <Button type="link" size="small">删除</Button>
                                </Popconfirm>
                            </>
                        )
                    }
                }

            } else {
                return initObj
            }
        })
        this.setState({
            columns: columns,
        })
    }

    initTableDataList() {
        this.setState({loading: true});
        getDataRightItem(this.state.formParam).then(res => {
            let resultData = {
                ...res,
                dataDetail: (res.dataDetail||[]).map(item=>{
                    item.fieldValue = (item.fieldValue?item.fieldValue.split(','):[])
                    return item
                })
            }
            console.log('res', resultData)

            this.setState({
                loading: false,
                formParam: {
                    ...resultData,
                    source:res.source||'默认',
                }
            })
            if (this.formRef.current) {
                this.formRef.current.setFieldsValue({...this.state.formParam})
            }

        })
    }
    getFieldsByLink = () => {
        this.setState({loading: true})
        getFieldDataRight({
            attachInfo:this.state.formParam.attachInfo,
            source:this.state.formParam.source,
        }).then(res => {
            let param = {...this.state.formParam}
            param.dataDetail = [
                ...res
            ]
            this.setState({
                loading: false,
                formParam: param
            })
            this.formRef.current.setFieldsValue({...param})

        })
    }
    validateMessages = {
        required: '${label} 为必填项!',
    }
    handleSubmit = () => {
        const {formParam} = this.state;
        let setParam = {...formParam}
        setParam.dataDetail = (formParam.dataDetail || []).map(item => {
            item.fieldValue = item.fieldValue?item.fieldValue.join(','):''
            return item
        })
        saveDataRightItem(setParam).then(res => {
            notification.success({
                message: '保存成功',
                duration: 1,
                onClose: () => {
                    this.props.history.go(-1)
                }
            });
        })
    }
    addField = () => {
        console.log('addField')
        let fields = []
        fields.push({
            fieldValue: [],
            fieldType: '字符',
            fieldName: '',
            fieldAliasName:'',
        })
        this.setState(
        prevState => ({
            formParam: {
                ...prevState.formParam,
                dataDetail: [...prevState.formParam.dataDetail, ...fields]
            }
        }),()=>{
                this.formRef.current.setFieldsValue({...this.state.formParam})

            })
    }
    deleteItem = (values,index)=> {
        console.log('deleteItem', values,index)
        if(values.id){
            delDataRightItemField({id:values.id}).then(res => {
                message.success('删除成功')
            })
        }
        let dataDetail = [...this.state.formParam.dataDetail]
        dataDetail.splice(index, 1)
        this.setState(
            prevState =>  ({
                    formParam: {
                        ...prevState.formParam,
                        dataDetail
                    }
                }),()=>{
                this.formRef.current.setFieldsValue({...this.state.formParam})

            })
    }
    formValueChange = (changedValues, allValues) => {
        console.log('cc', changedValues, allValues)
        if(changedValues.hasOwnProperty('dataDetail')){
            let parentIndex = Object.keys(changedValues.dataDetail)[0]
            let dataValue = Object.values(changedValues.dataDetail)[0]
            let {dataDetail} = this.state.formParam
            let param = [...dataDetail]
            console.log('parentIndex', parentIndex,dataValue,param[parentIndex])

            param[parentIndex] = {...param[parentIndex],...dataValue}
            console.log('param', param)
            this.setState(prevState => ({
                formParam: {
                    ...prevState.formParam,
                    dataDetail: [...param]
                }
            }))
        }else{
            this.setState(prevState => ({
                formParam: {
                    ...prevState.formParam,
                    ...changedValues,
                }
            }))
        }
        // this.setState({
        //     formParam: {
        //         ...param
        //     }
        // })
    }
    addColor = ()=>{
        console.log('addColor', this.state.newColor)
    }
    handleColorChange = (value)=>{
        console.log('handleColorChange', value.target.value)
        this.setState({
            newColor: value.target.value
        })
    }
    componentDidMount() {

        console.log(this.props.location, this.props.match, this.state.formParam)

        this.createColumns(columnsKey);
        if (this.state.formParam.id) {
            this.initTableDataList()
        } else {
            let param = {
                ...this.state.formParam,
            }
            this.setState({
                formParam: {...param}
            })
            this.formRef.current.setFieldsValue({...param})

        }

    }

    render() {
        const defaultTab = locationQuery.get('tab') ? locationQuery.get('tab') : 1;
        const {dataSource, columns, loading, visible, formParam, systemItem} = this.state;
        return (
            <>
                <Card title={

                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <div style={{marginRight: '50px'}} onClick={() => this.props.history.go(-1)}>
                            <Icon.ArrowLeftOutlined/> 业务数据详情
                        </div>
                        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                            {
                                this.state.currentTab === '1' ?
                                    <>
                                        <Button type="primary" danger
                                                onClick={() => this.handleSubmit()}>保存</Button>

                                    </> : ''
                            }
                        </div>
                    </div>
                } bordered={false}
                      className={'card-fixed-head-wrap data-right-detail'}
                >
                    <Form
                        {...layout}
                        ref={this.formRef}
                        name="basic"
                        labelAlign="right"
                        labelWrap={true}
                        preserve={false}
                        initialValues={formParam}
                        onValuesChange={this.formValueChange}
                        validateMessages={this.validateMessages}
                    >
                        <div className="task-tag" style={{
                            margin: '0 0 10px',
                            borderColor: '#27a5aa',
                            backgroundColor: '#e6fffb'
                        }}>业务数据信息
                        </div>
                        <Form.Item
                            shouldUpdate
                            label="业务ID"
                            name="bussId"
                            rules={[{required: true}]}

                        >
                            <Input placeholder="请输入"/>
                        </Form.Item>
                        <Form.Item
                            shouldUpdate
                            label="业务名"
                            name="bussName"
                            rules={[{required: true}]}

                        >
                            <Input maxLength={10} placeholder={'请输入'}/>
                        </Form.Item>
                        <Form.Item
                            label="数据来源"
                            name="source"
                            rules={[{required: true}]}
                            // help={
                            //     <span className={'form-tips'}>* 默认</span>}

                        >
                            <Radio.Group
                                options={this.state.dataSourceList}
                            />
                        </Form.Item>
                        {
                            this.state.formParam.source !== '默认' ?
                                <Form.Item
                                    label={this.state.formParam.source=='tools'?"formCode":(this.state.formParam.source=='sql'?"sql":"接口链接")}
                                    style={{flex: 1}}
                                >
                                    <div className="qus-wrap">
                                        <Form.Item name="attachInfo"
                                        >
                                            <Input.TextArea
                                                autoSize={{min: 4, maxRows: 10}}
                                                placeholder={this.state.formParam.source=='tools'?"请输入formCode":(this.state.formParam.source=='sql'?"请输入sql":"请输入接口链接")}/>

                                        </Form.Item>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'flex-end'
                                        }}>
                                            <Tag style={{
                                                cursor: 'pointer',
                                                padding: '3px 10px'
                                            }} color={'pink'}
                                                 onClick={() => this.getFieldsByLink()}>
                                                <Icon.MonitorOutlined/> 获取字段
                                            </Tag>
                                        </div>

                                    </div>
                                </Form.Item>
                                :''
                        }

                        <div className="task-tag" style={{
                            margin: '10px 0 10px',
                            borderColor: '#27a5aa',
                            backgroundColor: '#e6fffb',
                            display: 'flex', justifyContent: 'space-between'
                        }}>
                            <span>数据字段</span>
                            <Button size={'small'} type={'primary'} onClick={()=>this.addField()}>添加字段</Button>

                        </div>
                        <Table
                            className={'data-right-detail-table-wrap'}
                            bordered
                            size="small"
                            pagination={false}
                            dataSource={this.state.formParam.dataDetail||[]}
                            columns={columns}
                            rowKey={record => record.id}
                            scroll={{x: 1900}}
                            loading={loading}/>
                        {/*</Form>*/}
                    </Form>

                </Card>
            </>


        )
    }
}